import { useHref } from "@made-people/grease-link";
import { ButtonAsLink } from "@made-people/blueprint-button";
import { StoryblokComponent } from "@made-people/grease-storyblok";
import { useGeneralSettings } from "../../hooks/use-general-settings";
import { SbBlokData } from "@storyblok/js";
import { useTranslate } from "@made-people/grease-translations";
import { useRegisterForm } from "./hooks/use-register-form";
import { RegisterForm } from "./forms/RegisterForm";

export const AccountRegisterPageRoute = () => {
  const registerComponents = useGeneralSettings()?.register_content;
  const href = useHref();
  const translate = useTranslate();
  const form = useRegisterForm({
    onSuccess: () => {
      window.location.href = href("comfort-club");
    },
  });

  return (
    <>
      {registerComponents?.map((component: SbBlokData, index: number) => (
        <StoryblokComponent key={index} blok={component} />
      ))}
      <div className="mx-auto w-full max-w-screen-page-max-width md:px-component-spacing-lg xl:px-component-spacing-2xl">
        <div className="md:grid md:grid-cols-12 md:gap-x-1 min-h-[80vh]">
          <div className="md:col-start-4 md:col-span-6 w-full py-12 px-4 md:px-0">
            <RegisterForm
              form={form}
              loginAction={
                <ButtonAsLink
                  label={translate("Account_Signup_SecondaryAction")}
                  link={{ href: href("comfort-club/login") }}
                  variants={{ style: "outline", width: "full" }}
                />
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};
